export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5783.aa1a853d.jpg";